// -----------------------------------------------------------------------------
// NotFound.jsx – Page 404 alignée avec le style LandingPage
// -----------------------------------------------------------------------------
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Paper, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import leftBg from "../../assets/icons/landing-left-bg.png";

/* ────────────────────────────────────────────────────────────────────────── */
/*  🎨  Design tokens (identiques à LandingPage)                             */
/* ────────────────────────────────────────────────────────────────────────── */
const NAVY       = "#2F4E8B";
const NAVY_LIGHT = "#4a6bad";

export default function NotFound() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: `url(${leftBg}) no-repeat center / cover`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Paper
        elevation={8}
        sx={{
          maxWidth: 480,
          width: "100%",
          textAlign: "center",
          p: 4,
          borderRadius: 3,
          border: `2px solid ${NAVY}`,
          backgroundColor: "rgba(255,255,255,0.85)",
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 64, color: NAVY, mb: 1 }} />
        <Typography variant="h2" sx={{ fontWeight: 900, color: NAVY, mb: 1 }}>
          404
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2, color: "#6b6b6b" }}>
          Page non trouvée
        </Typography>
        <Typography variant="body1" sx={{ mb: 3, color: "#6b6b6b" }}>
          La page que vous recherchez n'existe pas.
        </Typography>
        <Button
          component={RouterLink}
          to="/acceuil"
          variant="contained"
          sx={{
            backgroundColor: NAVY,
            color: "#fff",
            fontWeight: 700,
            px: 3,
            "&:hover": { backgroundColor: NAVY_LIGHT },
          }}
        >
          Retour à l'accueil
        </Button>
      </Paper>
    </Box>
  );
}
